import { render, staticRenderFns } from "./ActionType.vue?vue&type=template&id=1f56cca0&scoped=true"
import script from "./ActionType.vue?vue&type=script&lang=js"
export * from "./ActionType.vue?vue&type=script&lang=js"
import style0 from "./ActionType.vue?vue&type=style&index=0&id=1f56cca0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f56cca0",
  null
  
)

export default component.exports